"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = exports.WkGallery = void 0;
require("./gallery.scss");
var Component_1 = require("../Component");
var util_1 = require("../util");
var WkGallery = /** @class */ (function (_super) {
    __extends(WkGallery, _super);
    function WkGallery(options) {
        var _this = _super.call(this, (options === null || options === void 0 ? void 0 : options.element) || util_1.htmlDiv()) || this;
        _this.$element.addClass('wk-gallery');
        _this.columns = (options === null || options === void 0 ? void 0 : options.columns) || 2;
        _this.dynamicColumns = options === null || options === void 0 ? void 0 : options.dynamicColumns;
        _this.singleImageStyle = options === null || options === void 0 ? void 0 : options.singleImageStyle;
        _this.$inner = util_1.$div('gallery-inner');
        _this.$element.append(_this.$inner);
        return _this;
    }
    WkGallery.prototype.getItemStyle = function (itemLength) {
        var columns = this.dynamicColumns ? this.dynamicColumns(itemLength) : this.columns;
        if (columns > 1) {
            return { width: (100 / columns).toFixed(2) + '%' };
        }
        else {
            return this.singleImageStyle || 'width: 100%;';
        }
    };
    WkGallery.prototype.update = function (images) {
        var _this = this;
        var $inner = this.$inner;
        var style = this.getItemStyle(images.length);
        $inner.empty();
        images.forEach(function (src, i) {
            $inner.append(util_1.$div('gallery-item')
                .tap(function ($) { return util_1.setStyle($.element, style); })
                .append(util_1.$div('img-wrapper fade-out')
                .append(util_1.$element('img', { src: src }).on('load', function (event) {
                var wrapper = event.target.parentElement;
                wrapper === null || wrapper === void 0 ? void 0 : wrapper.classList.remove('fade-out');
            }))
                .on('click', function () { return _this.onClickImage(i, src); })));
        });
        if (images.length > this.columns) {
            var spaces = images.length % this.columns;
            for (var i = 0; i < spaces; i++) {
                $inner.append(util_1.$div('gallery-item')
                    .tap(function ($) { return util_1.setStyle($.element, style); }));
            }
        }
    };
    WkGallery.prototype.onClickImage = function (index, src) {
        this.element.dispatchEvent(new CustomEvent('gallery-click', {
            detail: { index: index, src: src },
        }));
    };
    return WkGallery;
}(Component_1.Component));
exports.WkGallery = WkGallery;
function init(options) {
    return new WkGallery(options);
}
exports.init = init;
